import { IDeviationTeamDetailDTO, IDeviationTeamInfoDTO, IDeviationTeamRegionDirectorDetailDTO, IDeviationTeamRegionDirectorInfoDTO } from "api/swagger/ApiClient";
import { autoinject } from 'aurelia-framework';
import { DeviationTeamDataModel } from "model/forms/deviation-team-model";
import { DeviationTeamRegionDirectorDataModel } from "model/forms/deviation-team-region-director-model";
import { DeviationTeam, DeviationTeamRegionDirector } from "model/business-keywords";
import { BusinessTypesMapping } from "./business-types-mapping";
import { EssentialTypesMapping } from "./essential-types-mapping";

@autoinject
export class DeviationTeamsMapping {
  constructor(private businessTypesMapping: BusinessTypesMapping, private essentialTypesMapping: EssentialTypesMapping) {
  }

  mapToDeviationTeamDataModel(dto: IDeviationTeamDetailDTO): DeviationTeamDataModel {
    return {
      id: dto.id,
      name: dto.name,
      emailAddress: dto.emailAddress,
      teamType: dto.teamType,
      teamStrategy: dto.teamStrategy,
      teamLeader: dto.teamLeader != null ? this.businessTypesMapping.mapUserToUserContact(dto.teamLeader) : null
    }
  }

  mapToDeviationTeamRegionDirectorDataModel(dto: IDeviationTeamRegionDirectorDetailDTO): DeviationTeamRegionDirectorDataModel {
    return {
      id: dto.id,
      region: dto.region,
      director: this.businessTypesMapping.mapUserToUserContact(dto.director),
      isActive: dto.isActive,
      archivedBy: dto.archivedBy,
      archivedOn: dto.archivedOn
    }
  }

  mapToDeviationTeam(dto: IDeviationTeamInfoDTO): DeviationTeam {
    return {
      id: dto.id,
      name: dto.name,
      teamType: dto.teamType,
      teamLeader: dto.teamLeader !== null ? this.essentialTypesMapping.mapSystemUserInfoToUserInfo(dto.teamLeader) : null,
      members: dto.members.map(x => this.essentialTypesMapping.mapSystemUserInfoToUserInfo(x)),
      regionDirectors: dto.regionDirectors.map(x => this.mapToDeviationTeamRegionDirector(x))
    }
  }

  mapToDeviationTeamRegionDirector(dto: IDeviationTeamRegionDirectorInfoDTO): DeviationTeamRegionDirector {
    return {
      id: dto.id,
      region: dto.region,
      director: this.businessTypesMapping.mapUserToUserContact(dto.director)
    };
  }
}
